import script from "./FileAttachment.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileAttachment.vue?vue&type=script&setup=true&lang=ts"

import "./FileAttachment.vue?vue&type=style&index=0&id=6aa310bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aa310bc"]])

export default __exports__